import classNames from "classnames";
import React from "react";
import ReactMarkdown from "react-markdown";
import CodeBlock from "../CodeBlock";

export interface Props {
  id?: string;
  content: string;
  width: "full" | "prose";
}
const Markdown: React.FC<Props> = ({ content, width, id }) => {
  return (
    <div id={id}>
      <ReactMarkdown
        className={classNames("prose mx-auto scroll-mt-20", {
          "max-w-prose": width === "prose",
          "max-w-full": width === "full",
        })}
        linkTarget="_blank"
        components={{
          code({ node, inline, className, children, ...props }) {
            const match = /language-(\w+)/.exec(className || "");
            return !inline && match ? (
              <CodeBlock
                value={String(children).replace(/\n$/, "")}
                language={match[1]}
                {...props}
              />
            ) : (
              <code
                className={classNames(
                  className,
                  "after: rounded-sm bg-gray-200 px-1 font-mono text-solid-red before:text-red-950 after:text-red-950"
                )}
                {...props}
              >
                {children}
              </code>
            );
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

Markdown.defaultProps = {
  width: "prose",
  id: undefined,
};

export default Markdown;
